import { I18n } from '@calendly/i18n'
import PropTypes from 'prop-types'

export const MembershipRole = ({ membershipRole }) => ({
  user: I18n.t('publisher.organization.membership_role.user'),
  admin: I18n.t('publisher.organization.membership_role.admin'),
  owner: I18n.t('publisher.organization.membership_role.owner')
}[membershipRole])

MembershipRole.propTypes = {
  membershipRole: PropTypes.oneOf(['user', 'admin', 'owner']).isRequired
}
